<template>
  <vx-card no-shadow :title="$t(`ANALITICS.newAnalitic`)">
    <span v-html="$t(`ANALITICS.alert`)"></span>

    <!-- Info -->
    <vs-input
      class="w-full mb-base"
      :label-placeholder="$t(`ANALITICS.placeholderName`)"
      v-model="statisticName"
    ></vs-input>

    <vs-input class="w-full mb-base" :label-placeholder="$t(`ANALITICS.placeHolderUri`)" v-model="uri"></vs-input>

    <vs-select autocomplete class="selectExample w-full px-2" v-model="company" :label="$t('ANALITICS.selectCompany')">
      <vs-select-item :key="index" :value="company.key" :text="company.name" v-for="(company, index) in companies" />
    </vs-select>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" v-if="keyStatistic === null" @click="saveChanges">{{
        $t(`ANALITICS.save`)
      }}</vs-button>
      <vs-button class="ml-auto mt-2" v-else @click="updateChanges">{{ $t(`ANALITICS.update`) }}</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancelChanges">{{
        $t(`ANALITICS.clean`)
      }}</vs-button>
    </div>
  </vx-card>
</template>

<script>
import * as Statistics from "./Statistics";
import Utils from "@/helpers/Utils";

export default {
  props: {
    value: {
      required: false,
      type: Object
    },
    keyStatistic: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      statisticName: "",
      uri: "",
      company: "",
      companies: []
    };
  },
  mounted() {
    this.getcompanies();
    if (this.keyStatistic !== null) this.getOneStatistic(this.keyStatistic);
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    }
  },
  methods: {
    validate() {
      if (this.statisticName === null || this.statisticName === undefined) {
        this.$vs.notify({
          title: this.$t(`ANALITICS.newAnalitics`),
          text: this.$t(`ANALITICS.notifyName`),
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }
      if (this.statisticName.length < 2) {
        this.$vs.notify({
          title: this.$t(`ANALITICS.newAnalitics`),
          text: this.$t(`ANALITICS.notifyNameInvalid`),
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      return true;
    },
    async saveChanges() {
      if (!this.validate()) return;
      if(!Utils.urlDataStudio(this.uri)) {
        return this.$vs.notify({
          title: this.$t(`ANALITICS.tableStatistic`),
          text: this.$t(`ANALITICS.msgErrorUrlStatistic`),
          color: "warning",
          icon: "error",
          time: 4000
        });
      }     

      this.$vs.loading({ type: "sound" });

      try {
        const data = {
          name: this.statisticName,
          uri: this.uri,
          companyID: this.company
        };

        const result = await Statistics.saveStadistic(data);

        this.$emit("input", { name: this.statisticName, key: result.id });

        this.$vs.notify({
          title: this.$t(`ANALITICS.name`),
          text: this.$t(`ANALITICS.successStatistics`),
          iconPack: "feather",
          icon: "icon-bell",
          color: "primary",
          time: 6000
        });

        this.cancelChanges();
      } catch (error) {
        console.error("error", error);
        this.$vs.notify({
          title: this.$t(`ANALITICS.name`),
          text: `${this.$t(`ANALITICS.erroStatistics`)}(${error.message})`,
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async updateChanges() {
      if (!this.validate()) return;

      this.$vs.loading({ type: "sound" });
      try {
        const data = {
          name: this.statisticName,
          uri: this.uri,
          companyID: this.company
        };

        await Statistics.updateStadistic(this.keyStatistic, data);
        this.$emit("key");
        this.$vs.notify({
          title: this.$t(`ANALITICS.name`),
          text: this.$t(`ANALITICS.updateSuccessStatistic`),
          iconPack: "feather",
          icon: "icon-bell",
          color: "primary",
          time: 6000
        });

        this.cancelChanges();
      } catch (error) {
        console.error("error", error);
        this.$vs.notify({
          title: this.$t(`ANALITICS.name`),
          text: `${this.$t(`ANALITICS.erroStatistics`)}(${error.message})`,
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async getcompanies() {
      try {
        const result = await Statistics.getComapnies();
        this.companies = result;
      } catch (error) {
        console.log(`Error Statistics: getcompanies ${error}`);
      }
    },
    cancelChanges() {
      this.groupName = "";
      this.description = "";
    },
    async getOneStatistic(key) {
      try {
        const result = await Statistics.getOneStadistic(key);
        const { name, companyID, uri } = result;
        this.statisticName = name;
        this.uri = uri;
        this.company = companyID;
      } catch (error) {
        console.log("Error: getOneStatistic ", error);
      }
    }
  }
};
</script>
